import { constants } from '../constant/constant';
import { httpservice } from '../services';
import { dateFormat } from '../helper/StringUtils';
import { USER } from '../constant/actionTypes';

export const getSalesReps = () => (dispatch) => {
  const query = `${constants.API.SALES_REPS}`.replace('-', '');
  dispatch({
    payload: [],
    type: USER.GET.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];
      let count = 0;

      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      const responseData = rows && rows.length ? rows.map((data) => (
        {
          ...data,
          name: `${data.firstName} ${data.lastName}`,
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          created_at: dateFormat(data.createdAt),
        }
      )) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: USER.GET.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: USER.GET.ERROR,
      });
    });
};
